import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, takeUntil } from 'rxjs';
import { cancellationRequested, canvasRendererHostToken } from './canvas-renderer-host';

@Injectable()
export class CanvasRendererHostHttpInterceptor implements HttpInterceptor {
  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (canvasRendererHostToken) {
      request = request.clone({
        setHeaders: {
          'X-Insights-CanvasRendererHostToken': canvasRendererHostToken
        }
      });
    }

    return next.handle(request).pipe(
      takeUntil(cancellationRequested.observable)
    );
  }
}
